import { useQuery } from '@tanstack/react-query';
import { getAllProjects } from '../../services/api/implementation/impl';

// The projects the feed filter and Create Post both offer, sorted by name.
// One query key, so the two lists are always the same list.
const useFeedProjects = () => {
  const { data } = useQuery({
    queryKey: ['projects'],
    queryFn: () => getAllProjects()
  });
  return Array.isArray(data)
    ? [...data].sort((a, b) => (a?.name || '').localeCompare(b?.name || ''))
    : [];
};

export default useFeedProjects;
